var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.642578,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#373F47"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3652_11762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3555 8.47872C18.4822 7.00717 20.0485 7 20.0485 7C20.0485 7 20.2815 8.3835 19.1622 9.71626C17.9671 11.1393 16.6087 10.9065 16.6087 10.9065C16.6087 10.9065 16.3536 9.78727 17.3555 8.47872ZM16.752 11.8756C17.3316 11.8756 18.4073 11.0861 19.8075 11.0861C22.2177 11.0861 23.1659 12.7856 23.1659 12.7856C23.1659 12.7856 21.3115 13.7252 21.3115 16.005C21.3115 18.5769 23.6216 19.4632 23.6216 19.4632C23.6216 19.4632 22.0067 23.9675 19.8255 23.9675C18.8236 23.9675 18.0448 23.2984 16.9892 23.2984C15.9135 23.2984 14.846 23.9924 14.1507 23.9924C12.1589 23.9925 9.64258 19.7197 9.64258 16.2852C9.64258 12.9061 11.7725 11.1334 13.7703 11.1334C15.069 11.1334 16.0768 11.8756 16.752 11.8756Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3652_11762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 17,
    fill: "white",
    transform: "translate(9.64258 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.0769dc498df4607a0464f132f6d95e63.svg";
export { ForwardRef as ReactComponent };